const Kategoriya2411 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 4-chorak<br />
                Mavzu: Eng yaxshi ixtirolar <br />
“Eng oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Quyidagi so‘zlarga mos qo‘shimchalar qo‘shib, birikmalar hosil qiling.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning so‘z birikmalari haqidagi ko‘nikmalarini rivojlantirish.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa.<br />
            <p>Bolalar___ katta__</p>
            <p>Buvim____ ko‘zoyna___</p>
            <p>Daryo____ chet___</p>
            <p>Maktab___ bordi__</p>
            <p><b>2-mashq. Aralash berilgan so‘zlarni ozlarni o‘z o‘rniga qo‘yib, gaplar hosil qiling.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">eksponantni qorachig‘idek muzey ko‘z asrashadi xodimlari har bir
______________________________________________________________
</p>
<p className="text-break">olam-olam quyoshning kishilarga bag‘ishlaydi tafti quvonch
____________________________________________________________
</p>
            <p><b>3-mashq. Yangi so‘zlar ishtirokida gaplar tuzing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">Bloger - _________________________________________________________</p>
            <p className="text-break">Vayn - _______________________________________________________</p>
        </div>
    )
}
export default Kategoriya2411;